import { render, staticRenderFns } from "./EmployerDashboard.vue?vue&type=template&id=2a35a4ce&"
import script from "./EmployerDashboard.vue?vue&type=script&lang=js&"
export * from "./EmployerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports